/**
 * Returns the credit cost for a single generation based on the selected model.
 *
 * Ultra  (Gemini 3.1 Flash Image Preview) → 1 credit
 * Lite   (Flux Pro)                       → 1 credit
 * Lite Creative (Flux Flex)               → 2 credits
 */
export function getModelCreditCost(modelValue) {
  if (modelValue === 'Flux Flex') return 2;
  return 1;
}
